let state = {
  userDetails: {
    address: {
      city: undefined,
      country: 'India',
      line1: undefined,
      line2: undefined,
      postcode: undefined,
      state: undefined
    },
    education: '',
    employmentDetail: {
      address: {
        city: undefined,
        country: 'India',
        line1: undefined,
        line2: undefined,
        postcode: undefined,
        state: undefined
      },
      nameOfFirmCompanyEstablishment: undefined,
      workingSince: undefined
    },
    income: 20000,
    pan: undefined,
    salaried: false,
    vid: undefined,
    isWebRequest: true
  },
  appliedToDmi: undefined,
  invalidEmploymentPinCode: false,
  invalidPersonalPinCode: false,
  disablePanField: false
}
export default state



// WEBPACK FOOTER //
// ./src/store/dmi/state.js